import FaIcon from "../utils/FaIcon";
import ModBoxTDS from "../docs/TDS/Technical Data Sheet - Modular Box.pdf";

export const CableTrays = [
  { name: 'Ladder Cable Trays', id: 'ladder' },
  { name: 'Raceway Cable Trays', id: 'raceway' },
  { name: 'Perforated Cable Trays', id: 'perforated' },
  { name: 'Universal Accessories', id: 'universal' },
];

export const TypeMap = {
  'ladder': "LCT",
  'raceway': "RCT",
  'perforated': "PCT",
  'universal': "UAC",
};

export const CoatingTypes = [
  { name: 'Hot Dip Galvanized', code: 'HD' },
  { name: 'Pre-Galvanized', code: 'PG' },
  { name: 'Powder Coated', code: 'PC' },
];

export const TrayWidths = [
  { name: '50mm', code: '50' },
  { name: '100mm', code: '100' },
  { name: '150mm', code: '150' },
  { name: '200mm', code: '200' },
  { name: '300mm', code: '300' },
  { name: '400mm', code: '400' },
  { name: '500mm', code: '500' },
  { name: '600mm', code: '600' },
  { name: '750mm', code: '750' },
  { name: '800mm', code: '800' },
  { name: '900mm', code: '900' },
  { name: '1000mm', code: '1000' },
  { name: '1200mm', code: '1200' },
];

export const TrayHeights = [
  { name: '25mm', code: '25' },
  { name: '40mm', code: '40' },
  { name: '50mm', code: '50' },
  { name: '75mm', code: '75' },
  { name: '100mm', code: '100' },
];

export const TrayThicknesses = [
  { name: '1.6mm - N', code: 'N' },
  { name: '2.0mm - H', code: 'H' },
  { name: '2.5mm - E', code: 'E' },
  { name: '5.0mm - M', code: 'M' },
];

export const TechTable = {
  cat1: <table class="product-availability-table">
    <thead>
      <tr>
        <th colSpan="2">Technical Details</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Side Collar</td>
        <td>50x15mm, 75×15, 100×15 &amp; 50×20, 75×20, 100x20mm</td>
      </tr>
      <tr>
        <td>Rung Size</td>
        <td>35x15x5mm, 40x15x5mm</td>
      </tr>
      <tr>
        <td>Rung Length</td>
        <td>W – 4mm</td>
      </tr>
      <tr>
        <td>Rung Thickness</td>
        <td>1.5, 2.0, 2.5, 3.0mm</td>
      </tr>
      <tr>
        <td>Rung to Rung Distance</td>
        <td>250mm, 275mm, 300mm c/c</td>
      </tr>
    </tbody>
  </table>,
  cat2: <ul>
    <li><strong>Perforation Provided on Rung:</strong> Yes</li>
    <li><strong>Perforation Type:</strong> Oblong horizontal slots (20x10mm)</li>
    <li><strong>Perforation Percentage:</strong> 17%</li>
  </ul>,
};

export const AvailabilityTable = {
  cat1: <table class="product-availability-table">
    <thead>
      <tr>
        <th colSpan="2">Availability</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Tray Width Range</td>
        <td>50mm to 1200mm</td>
      </tr>
      <tr>
        <td>Side Collar (Height)</td>
        <td>25mm to 100mm</td>
      </tr>
      <tr>
        <td>Available Thicknesses</td>
        <td>N-1.6, H-2.0, E-2.5, M-5.0mm</td>
      </tr>
      <tr>
        <td>Standard Tray Lengths</td>
        <td>3m, 4m, 6m, 8m</td>
      </tr>
    </tbody>
  </table>
};

export const ModBoxDetails = {
  ModularBox: <div className="product-info">
    <ul>
      <li>
        <div className='list-bullet'><FaIcon icon="lock" color={'#e47931'} /></div>
        <strong>Advanced locking technology:</strong> Ensures a secure fit for the box cover, preventing accidental opening and enhancing safety during operation and maintenance. This sophisticated locking mechanism provides assurance by keeping electrical components securely enclosed, reducing the risk of tampering or inadvertent exposure.
      </li>
      <li>
        <div className='list-bullet'><FaIcon icon="plug-circle-check" color={'#e47931'} /></div>
        <strong>Universal modular switch compatibility:</strong> Accommodates a wide range of modular switches from various brands and sizes, offering flexibility for diverse electrical installations. This universal compatibility facilitates easy upgrades or modifications without necessitating box replacement.
      </li>
      <li>
        <div className='list-bullet'><FaIcon icon="shield" color={'#e47931'} /></div>
        <strong>Manufactured from GI Sheet:</strong> Constructed using premium-quality Galvanized Iron (GI) sheet, providing exceptional durability, strength, and corrosion resistance. The robust material ensures reliable performance even in demanding environments.
      </li>
      <li>
        <div className='list-bullet'><FaIcon icon="paintbrush" color={'#e47931'} /></div>
        <strong>Available in multiple colors:</strong> Offered in a variety of color options to complement interior aesthetics and design preferences, enabling seamless integration with diverse décor styles and enhancing visual appeal.
      </li>
      <li>
        <div className='list-bullet'><FaIcon icon="feather" color={'#e47931'} /></div>
        <strong>Anti-rust coating:</strong> Features a protective coating that prevents rust and extends the product’s lifespan, even in humid or corrosive environments. This ensures the box maintains its structural integrity and appearance over time.
      </li>
      <li>
        <div className='list-bullet'><FaIcon icon="screwdriver-wrench" color={'#e47931'} /></div>
        <strong>Reliable earthing terminal:</strong> Equipped with a robust earthing terminal to ensure proper grounding and enhance electrical safety, minimizing the risk of electric shock and ensuring compliance with safety standards.
      </li>
      <li>
        <div className='list-bullet'><FaIcon icon="screwdriver" color={'#e47931'} /></div>
        <strong>Sturdy screw mounting:</strong> Designed with reinforced screw holes and mounting points for secure and stable installation on walls or surfaces, preventing loosening over time and supporting the weight of switches and accessories.
      </li>
      <li>
        <div className='list-bullet'><FaIcon icon="check-circle" color={'#e47931'} /></div>
        <strong>Tested as per BIS requirements:</strong> Manufactured and tested in accordance with Bureau of Indian Standards (BIS) regulations, ensuring superior quality and safety. This certification guarantees compliance with stringent national standards for electrical installations.
      </li>
    </ul>
    <br />
    <h2>Technical Specifications</h2>
    <h3>Concealed GI Metal Boxes (20 Gauge)</h3>
    <table>
      <thead>
        <tr>
          <th>Item</th>
          <th>Dimensions (L x W x H)</th>
          <th>Wall Thickness</th>
          <th>Coating</th>
          <th>No. of Knockouts</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1/2 Module</td>
          <td>81 x 78 x 52</td>
          <td>0.9 mm</td>
          <td>120 GSM</td>
          <td>9</td>
        </tr>
        <tr>
          <td>3 Module</td>
          <td>102 x 78 x 52</td>
          <td>0.9 mm</td>
          <td>120 GSM</td>
          <td>9</td>
        </tr>
        <tr>
          <td>4 Module</td>
          <td>136 x 75 x 51</td>
          <td>0.9 mm</td>
          <td>120 GSM</td>
          <td>11</td>
        </tr>
        <tr>
          <td>6 Module</td>
          <td>209 x 78 x 52</td>
          <td>0.9 mm</td>
          <td>120 GSM</td>
          <td>17</td>
        </tr>
        <tr>
          <td>8 Module (HOR)</td>
          <td>228 x 78 x 52</td>
          <td>0.9 mm</td>
          <td>120 GSM</td>
          <td>17</td>
        </tr>
        <tr>
          <td>8 Module (SQ)</td>
          <td>134 x 139 x 49</td>
          <td>0.9 mm</td>
          <td>120 GSM</td>
          <td>13</td>
        </tr>
        <tr>
          <td>12 Module</td>
          <td>205 x 139 x 49</td>
          <td>0.9 mm</td>
          <td>120 GSM</td>
          <td>19</td>
        </tr>
        <tr>
          <td>16 Module</td>
          <td>231 x 147 x 60</td>
          <td>0.9 mm</td>
          <td>120 GSM</td>
          <td>19</td>
        </tr>
        <tr>
          <td>18 Module</td>
          <td>207 x 200 x 61</td>
          <td>0.9 mm</td>
          <td>120 GSM</td>
          <td>18</td>
        </tr>
      </tbody>
    </table>
    <h3>Concealed GI Metal Boxes (18 Gauge)</h3>
    <table>
      <thead>
        <tr>
          <th>Item</th>
          <th>Dimensions (L x W x H)</th>
          <th>Wall Thickness</th>
          <th>Coating</th>
          <th>No. of Knockouts</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1/2 Module</td>
          <td>76 x 75 x 49</td>
          <td>1.2 mm</td>
          <td>120 GSM</td>
          <td>9</td>
        </tr>
        <tr>
          <td>3 Module</td>
          <td>98 x 75 x 49</td>
          <td>1.2 mm</td>
          <td>120 GSM</td>
          <td>9</td>
        </tr>
        <tr>
          <td>4 Module</td>
          <td>134 x 75 x 49</td>
          <td>1.2 mm</td>
          <td>120 GSM</td>
          <td>11</td>
        </tr>
        <tr>
          <td>6 Module</td>
          <td>206 x 75 x 49</td>
          <td>1.2 mm</td>
          <td>120 GSM</td>
          <td>14</td>
        </tr>
        <tr>
          <td>8 Module (HOR)</td>
          <td>233 x 79 x 49</td>
          <td>1.2 mm</td>
          <td>120 GSM</td>
          <td>9</td>
        </tr>
        <tr>
          <td>8 Module (SQ)</td>
          <td>134 x 139 x 49</td>
          <td>1.2 mm</td>
          <td>120 GSM</td>
          <td>17</td>
        </tr>
        <tr>
          <td>12 Module</td>
          <td>207 x 139 x 49</td>
          <td>1.2 mm</td>
          <td>120 GSM</td>
          <td>19</td>
        </tr>
        <tr>
          <td>16 Module</td>
          <td>235 x 148 x 60</td>
          <td>1.2 mm</td>
          <td>120 GSM</td>
          <td>10</td>
        </tr>
        <tr>
          <td>18 Module</td>
          <td>207 x 200 x 61</td>
          <td>1.2 mm</td>
          <td>120 GSM</td>
          <td>18</td>
        </tr>
      </tbody>
    </table>
    <h3>Concealed GI Metal Boxes (16 Gauge)</h3>
    <table>
      <tr>
        <th>Item</th>
        <th>Dimensions (L x W x H)</th>
        <th>Wall Thickness</th>
        <th>Coating</th>
        <th>No. of Knockouts</th>
      </tr>
      <tr>
        <td>1/2 Module</td>
        <td>76 x 76 x 40</td>
        <td>1.2 mm</td>
        <td>120 GSM</td>
        <td>9</td>
      </tr>
      <tr>
        <td>3 Module</td>
        <td>100 x 76 x 40</td>
        <td>1.2 mm</td>
        <td>120 GSM</td>
        <td>9</td>
      </tr>
      <tr>
        <td>4 Module</td>
        <td>136 x 76 x 40</td>
        <td>1.2 mm</td>
        <td>120 GSM</td>
        <td>11</td>
      </tr>
      <tr>
        <td>6 Module</td>
        <td>208 x 76 x 40</td>
        <td>1.2 mm</td>
        <td>120 GSM</td>
        <td>14</td>
      </tr>
      <tr>
        <td>8 Module (HOR)</td>
        <td>230 x 76 x 40</td>
        <td>1.2 mm</td>
        <td>120 GSM</td>
        <td>9</td>
      </tr>
      <tr>
        <td>8 Module (SQ)</td>
        <td>137 x 135 x 40</td>
        <td>1.2 mm</td>
        <td>120 GSM</td>
        <td>17</td>
      </tr>
      <tr>
        <td>12 Module</td>
        <td>209 x 135 x 40</td>
        <td>1.2 mm</td>
        <td>120 GSM</td>
        <td>19</td>
      </tr>
      <tr>
        <td>16 Module</td>
        <td>235 x 148 x 60</td>
        <td>1.2 mm</td>
        <td>120 GSM</td>
        <td>10</td>
      </tr>
      <tr>
        <td>18 Module</td>
        <td>207 x 200 x 61</td>
        <td>1.2 mm</td>
        <td>120 GSM</td>
        <td>18</td>
      </tr>
    </table>
    <h3>Technical Data Sheet</h3>
    <iframe src={ModBoxTDS} title="Modular Box Technical Data Sheet" width="100%" height="1050px" style={{ border: 'none' }}></iframe>
  </div>,
  FanBox: <div className="product-info">
    <ul>
      <li>
        <div className='list-bullet'>
          <FaIcon icon="fan" color={'#e47931'} />
        </div>
        <strong>Refined octagonal design:</strong> The fan box features an octagonal shape, providing enhanced structural integrity and a contemporary appearance. This design also facilitates improved cable management and simplifies the installation of ceiling fans or fixtures.
      </li>
      <li>
        <div className='list-bullet'>
          <FaIcon icon="palette" color={'#e47931'} />
        </div>
        <strong>Available in various colors:</strong> The fan box is offered in multiple color options, allowing seamless coordination with your room's décor or ceiling finish for a cohesive look.
      </li>
      <li>
        <div className='list-bullet'>
          <FaIcon icon="wrench" color={'#e47931'} />
        </div>
        <strong>Designed for effortless disassembly:</strong> The construction enables quick and hassle-free disassembly, streamlining maintenance, inspection, or replacement of internal components.
      </li>
      <li>
        <div className='list-bullet'>
          <FaIcon icon="feather" color={'#e47931'} />
        </div>
        <strong>Anti-rust coating for durability:</strong> A specialized anti-rust coating protects the box from corrosion, ensuring long-term reliability and preserving its appearance even in humid or challenging environments.
      </li>
      <li>
        <div className='list-bullet'>
          <FaIcon icon="screwdriver-wrench" color={'#e47931'} />
        </div>
        <strong>Reliable earthing terminal for safety:</strong> Outfitted with a dependable earthing terminal, the fan box ensures proper grounding, mitigating the risk of electrical hazards and enhancing user safety.
      </li>
      <li>
        <div className='list-bullet'>
          <FaIcon icon="circle-check" color={'#e47931'} />
        </div>
        <strong>Tested as per BIS requirements for quality assurance:</strong> The fan box is manufactured and tested in accordance with Bureau of Indian Standards (BIS), guaranteeing compliance with national safety and quality standards.
      </li>
    </ul>
  </div>,
  ConcealedBox: <div className="product-info">
    <ul>
      <li>
        <div className='list-bullet'>
          <FaIcon icon="lock" color={'#e47931'} />
        </div>
        <strong>Advanced locking technology:</strong> Ensures a secure fit for the box cover, preventing accidental opening and enhancing safety during operation and maintenance.
      </li>
      <li>
        <div className='list-bullet'>
          <FaIcon icon="lightbulb" color={'#e47931'} />
        </div>
        <strong>Compatible with a comprehensive range of LEDs:</strong> Accommodates various LED fixtures, providing flexibility for diverse lighting installations and ensuring optimal performance.
      </li>
      <li>
        <div className='list-bullet'>
          <FaIcon icon="shield" color={'#e47931'} />
        </div>
        <strong>Manufactured from GI Sheet:</strong> Constructed using high-quality Galvanized Iron (GI) sheet, offering durability, strength, and resistance to corrosion.
      </li>
      <li>
        <div className='list-bullet'>
          <FaIcon icon="screwdriver" color={'#e47931'} />
        </div>
        <strong>Design enables easy disassembly:</strong> The construction allows for quick and straightforward disassembly, facilitating maintenance, inspection, or replacement of internal components.
      </li>
      <li>
        <div className='list-bullet'>
          <FaIcon icon="check-circle" color={'#e47931'} />
        </div>
        <strong>Tested as per BIS requirements for quality assurance:</strong> The concealed box is manufactured and tested in accordance with Bureau of Indian Standards (BIS), ensuring compliance with national safety and quality standards.
      </li>
    </ul>
  </div>,
  JunctionBox: <div className="product-info">
    <ul>
      <li>
        <div className='list-bullet'>
          <FaIcon icon="cubes" color={'#e47931'} />
        </div>
        <strong>Exceptionally robust design:</strong> Engineered for maximum durability, ensuring long-lasting performance even in the most demanding environments.
      </li>
      <li>
        <div className='list-bullet'>
          <FaIcon icon="shield" color={'#e47931'} />
        </div>
        <strong>Outstanding strength:</strong> Built to withstand substantial loads and impacts, providing reliable protection for electrical connections.
      </li>
      <li>
        <div className='list-bullet'>
          <FaIcon icon="sheet-plastic" color={'#e47931'} />
        </div>
        <strong>Fabricated from CRC Sheet:</strong> Manufactured from high-quality Cold Rolled Steel (CRC) sheet, offering excellent strength and resistance to wear and tear.
      </li>
      <li>
        <div className='list-bullet'>
          <FaIcon icon="brush" color={'#e47931'} />
        </div>
        <strong>Zinc and powder-coated finish:</strong> Features a dual-layer coating of zinc and powder for superior corrosion resistance and enhanced aesthetic appeal.
      </li>
      <li>
        <div className='list-bullet'>
          <FaIcon icon="check-circle" color={'#e47931'} />
        </div>
        <strong>Tested as per BIS requirements:</strong> Manufactured and tested in accordance with Bureau of Indian Standards (BIS), ensuring exceptional quality and safety.
      </li>
    </ul>
  </div>,
  ShaftDoors: <div className="product-info">
    <ul>
      <li>
        <div className='list-bullet'>
          <FaIcon icon="shield" color={'#e47931'} />
        </div>
        <strong>Maximum safety and security:</strong> Designed to provide optimal protection for electrical installations, ensuring the safety of both equipment and personnel.
      </li>
      <li>
        <div className='list-bullet'>
          <FaIcon icon="wrench" color={'#e47931'} />
        </div>
        <strong>Easy installation:</strong> Engineered for straightforward installation, minimizing downtime and simplifying the setup process.
      </li>
      <li>
        <div className='list-bullet'>
          <FaIcon icon="hammer" color={'#e47931'} />
        </div>
        <strong>Robust construction:</strong> Built with high-quality materials to ensure durability and long-lasting performance, even in challenging environments.
      </li>
      <li>
        <div className='list-bullet'>
          <FaIcon icon="tools" color={'#e47931'} />
        </div>
        <strong>Low maintenance:</strong> Designed to require minimal upkeep, reducing long-term maintenance costs and enhancing reliability.
      </li>
      <li>
        <div className='list-bullet'>
          <FaIcon icon="feather" color={'#e47931'} />
        </div>
        <strong>Rust-proof & extended service life:</strong> Coated with anti-rust materials to ensure longevity and resistance to corrosion, extending the product's service life.
      </li>
      <li>
        <div className='list-bullet'>
          <FaIcon icon="bolt" color={'#e47931'} />
        </div>
        <strong>High strength & withstands extreme climatic conditions:</strong> Engineered to endure harsh weather and environmental conditions, providing reliable performance in various climates.
      </li>
    </ul>
  </div>
}
